<template>
  <section>
    <div class="card">
      <div class="card-header">
        <div class="utils__title">
          <strong>Objednávky - Detail <span class="utils__link--underlined text-primary">#{{ this.id }}</span></strong>
        </div>
        <action-tools :router-options="routerOptions" :handle-refresh="handleRefresh"></action-tools>
      </div>
      <div class="card-body">
        <div class="table-operations">
          <a-tabs @change="key => onTabChange(key, 'tabActiveKey')" :activeKey="tabActiveKey">
            <a-tab-pane v-for="item in tabList" :tab="item.tab" :key="item.key"></a-tab-pane>
          </a-tabs>
        </div>
      </div>
    </div>

    <div v-if="detail !== null">
      <div v-if="tabActiveKey === 'info'">
        <a-row type="flex" justify="start" :gutter="30">
          <a-col :xl="6" :md="8" :sm="12" :xs="24">
            <div class="card card--withShadow card--more_on-hover">
              <div class="card-header">
                <div class="utils__title">
                  <strong>Detail objednávky</strong>
                </div>
                <div class="card--more">
                  <a-button type="circle" icon="edit" @click="editable.info = true"></a-button>
                </div>
              </div>
              <div class="card-body">
                <div v-if="!editable.info">
                  <abbr title="ID" class="mr-2">ID:</abbr>{{ this.id }}<br>
                  <abbr title="Jazyk zákazníka" class="mr-2">Jazyk:</abbr>{{ detail.order_info.lge_name }}<br>
                  <abbr title="Měna zákazníka" class="mr-2">Měna:</abbr>{{ detail.order_info.currency_name }} [{{ detail.order_info.currency_symbol}}]<br>
                  <abbr title="Kurz v době nákupu" class="mr-2">Kurz:</abbr>{{ detail.order_info.currency_rate | currency }} / {{ detail.order_info.currency_amount + " " + detail.order_info.currency_symbol }}<br>
                  <abbr title="Objednáno" class="mr-2">Objednáno:</abbr>{{ toLocaleDate(detail.order_info.created_at) }}<br>
                  <abbr title="Status" class="mr-2">Status:</abbr>
                  <a-tag :color="statuses.find(x => x.status === detail.order_info.status).color">
                    {{ statuses.find(x => x.status === detail.order_info.status).text }}
                  </a-tag><br>
                  <abbr title="Uživatel" class="mr-2">Uživatel:</abbr>
                  <router-link class="utils__link--blue utils__link--underlined" :to="'/user/registered/detail/' + detail.order_info.uer_id" v-if="detail.order_info.uer_type === 'RID'">#{{ detail.order_info.uer_id }}</router-link>
                  <router-link class="utils__link--blue utils__link--underlined" :to="'/user/admin/detail/' + detail.order_info.uer_id" v-if="detail.order_info.uer_type === 'AMR'">#{{ detail.order_info.uer_id }}</router-link>
                  <span v-else>#{{ detail.order_info.uer_id }}</span>
                </div>
                <a-form :form="forms.info" layout="horizontal" @submit="updateInfo($event, forms.info, 'info')" v-else>
                  <a-form-item
                    label="Status"
                    :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol"
                    :validate-status="error('status') ? 'error' : ''"
                    :help="error('status') || ''"
                  >
                    <a-select v-decorator="['status', { initialValue: detail.order_info.status, rules: [{required: true, message: 'Status musí být vyplněn!'}]}]">
                      <a-select-option v-for="(status, index) in statuses" :value="status.status" :key="'status'+index">{{ status.text }}</a-select-option>
                    </a-select>
                  </a-form-item>
                  <div class="form-actions">
                    <a-button class="mr-2" @click="editable.info = false" type="default">Zrušit</a-button>
                    <a-button html-type="submit" type="primary" :disabled="loading || hasErrors(forms.info.getFieldsError())">Upravit</a-button>
                  </div>
                </a-form>
              </div>
            </div>
          </a-col>
          <a-col :xl="6" :md="8" :sm="12" :xs="24">
            <div class="card card--withShadow card--more_on-hover">
              <div class="card-header">
                <div class="utils__title">
                  <strong>Fakturační adresa</strong>
                </div>
                <div class="card--more">
                  <a-button type="circle" icon="edit" @click="editable.big = true"></a-button>
                </div>
              </div>
              <div class="card-body">
                <address v-if="!editable.big">
                  {{ detail.order_info.big_first_name + " " + detail.order_info.big_last_name }}<br>
                  {{ detail.order_info.big_street }}<br>
                  {{ detail.order_info.big_city }}<br>
                  {{ detail.order_info.big_zip }}<br>
                  <div v-if="countries.length === 0">
                    {{ detail.order_info.big_country }}<br>
                  </div>
                  <div v-else>
                    {{ countryName(detail.order_info.big_cty_id ) }}
                  </div>
                </address>
                <a-form :form="forms.big" layout="horizontal" @submit="updateAddress($event, detail.order_info.big_ahe_id, forms.big, 'big')" v-else>
                  <a-form-item
                    label="Jméno"
                    :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol"
                    :validate-status="error('ahe_first_name') ? 'error' : ''"
                    :help="error('ahe_first_name') || ''"
                  >
                    <a-input placeholder="Jméno" v-decorator="['ahe_first_name', { initialValue: detail.order_info.big_first_name, rules: [{max: 30, message: 'Jméno nemůže být delší než 30 znaků!'}]}]"/>
                  </a-form-item>
                  <a-form-item
                    label="Příjmení"
                    :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol"
                    :validate-status="error('ahe_last_name') ? 'error' : ''"
                    :help="error('ahe_last_name') || ''"
                  >
                    <a-input placeholder="Příjmení" v-decorator="['ahe_last_name', { initialValue: detail.order_info.big_last_name, rules: [{max: 40, message: 'Příjmení nemůže být delší než 40 znaků!'}]}]"/>
                  </a-form-item>
                  <a-form-item
                    label="Ulice"
                    :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol"
                    :validate-status="error('ahe_street') ? 'error' : ''"
                    :help="error('ahe_street') || ''"
                  >
                    <a-input placeholder="Ulice" v-decorator="['ahe_street', { initialValue: detail.order_info.big_street, rules: [{max: 60, message: 'Ulice nemůže být delší než 60 znaků!'}, {required: true, message: 'Ulice musí být vyplněno!'}]}]"/>
                  </a-form-item>
                  <a-form-item
                    label="Město"
                    :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol"
                    :validate-status="error('ahe_city') ? 'error' : ''"
                    :help="error('ahe_city') || ''"
                  >
                    <a-input placeholder="Město" v-decorator="['ahe_city', { initialValue: detail.order_info.big_city, rules: [{max: 60, message: 'Město nemůže být delší než 60 znaků!'}, {required: true, message: 'Město musí být vyplněno!'}]}]"/>
                  </a-form-item>
                  <a-form-item
                    label="PSČ"
                    :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol"
                    :validate-status="error('ahe_zip') ? 'error' : ''"
                    :help="error('ahe_zip') || ''"
                  >
                    <a-input placeholder="PSČ" v-decorator="['ahe_zip', { initialValue: detail.order_info.big_zip, rules: [{max: 10, message: 'PSČ nemůže být delší než 10 znaků!'}, {required: true, message: 'PSČ musí být vyplněno!'}]}]"/>
                  </a-form-item>
                  <a-form-item
                    label="Země"
                    :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol"
                    :validate-status="error('cty_id') ? 'error' : ''"
                    :help="error('cty_id') || ''"
                  >
                    <a-select v-decorator="['cty_id', { initialValue: detail.order_info.big_cty_id, rules: [{required: true, message: 'Země musí být vyplněna!'}]}]">
                      <a-select-option v-for="country in countries" :value="country.id" :key="'big_cty_id'+country.id" :loading="loading">{{ country.languages[0].pivot.name }}</a-select-option>
                    </a-select>
                  </a-form-item>
                  <div class="form-actions">
                    <a-button class="mr-2" @click="editable.big = false" type="default">Zrušit</a-button>
                    <a-button html-type="submit" type="primary" :disabled="loading || hasErrors(forms.big.getFieldsError())">Upravit</a-button>
                  </div>
                </a-form>
              </div>
            </div>
          </a-col>
          <a-col :xl="6" :md="8" :sm="12" :xs="24">
            <div class="card card--withShadow card--more_on-hover">
              <div class="card-header">
                <div class="utils__title">
                  <strong>Dodací adresa</strong>
                </div>
                <div class="card--more">
                  <a-button type="circle" icon="edit" @click="editable.dly = true"></a-button>
                </div>
              </div>
              <div class="card-body">
                <address v-if="!editable.dly">
                  {{ detail.order_info.dly_first_name + " " + detail.order_info.dly_last_name }}<br>
                  {{ detail.order_info.dly_street }}<br>
                  {{ detail.order_info.dly_city }}<br>
                  {{ detail.order_info.dly_zip }}<br>
                  <div v-if="countries.length === 0">
                    {{ detail.order_info.dly_country }}<br>
                  </div>
                  <div v-else>
                    {{ countryName(detail.order_info.dly_cty_id ) }}
                  </div>
                </address>
                <a-form :form="forms.dly" layout="horizontal" @submit="updateAddress($event, detail.order_info.dly_ahe_id, forms.dly, 'dly')" v-else>
                  <a-form-item
                    label="Jméno"
                    :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol"
                    :validate-status="error('ahe_first_name') ? 'error' : ''"
                    :help="error('ahe_first_name') || ''"
                  >
                    <a-input placeholder="Jméno" v-decorator="['ahe_first_name', { initialValue: detail.order_info.dly_first_name, rules: [{max: 30, message: 'Jméno nemůže být delší než 30 znaků!'}]}]"/>
                  </a-form-item>
                  <a-form-item
                    label="Příjmení"
                    :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol"
                    :validate-status="error('ahe_last_name') ? 'error' : ''"
                    :help="error('ahe_last_name') || ''"
                  >
                    <a-input placeholder="Příjmení" v-decorator="['ahe_last_name', { initialValue: detail.order_info.dly_last_name, rules: [{max: 40, message: 'Příjmení nemůže být delší než 40 znaků!'}]}]"/>
                  </a-form-item>
                  <a-form-item
                    label="Ulice"
                    :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol"
                    :validate-status="error('ahe_street') ? 'error' : ''"
                    :help="error('ahe_street') || ''"
                  >
                    <a-input placeholder="Ulice" v-decorator="['ahe_street', { initialValue: detail.order_info.dly_street, rules: [{max: 60, message: 'Ulice nemůže být delší než 60 znaků!'}, {required: true, message: 'Ulice musí být vyplněno!'}]}]"/>
                  </a-form-item>
                  <a-form-item
                    label="Město"
                    :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol"
                    :validate-status="error('ahe_city') ? 'error' : ''"
                    :help="error('ahe_city') || ''"
                  >
                    <a-input placeholder="Město" v-decorator="['ahe_city', { initialValue: detail.order_info.dly_city, rules: [{max: 60, message: 'Město nemůže být delší než 60 znaků!'}, {required: true, message: 'Město musí být vyplněno!'}]}]"/>
                  </a-form-item>
                  <a-form-item
                    label="PSČ"
                    :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol"
                    :validate-status="error('ahe_zip') ? 'error' : ''"
                    :help="error('ahe_zip') || ''"
                  >
                    <a-input placeholder="PSČ" v-decorator="['ahe_zip', { initialValue: detail.order_info.dly_zip, rules: [{max: 10, message: 'PSČ nemůže být delší než 10 znaků!'}, {required: true, message: 'PSČ musí být vyplněno!'}]}]"/>
                  </a-form-item>
                  <a-form-item
                    label="Země"
                    :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol"
                    :validate-status="error('cty_id') ? 'error' : ''"
                    :help="error('cty_id') || ''"
                  >
                    <a-select v-decorator="['cty_id', { initialValue: detail.order_info.dly_cty_id, rules: [{required: true, message: 'Země musí být vyplněna!'}]}]">
                      <a-select-option v-for="country in countries" :value="country.id" :key="'dly_cty_id'+country.id" :loading="loading">{{ country.languages[0].pivot.name }}</a-select-option>
                    </a-select>
                  </a-form-item>
                  <div class="form-actions">
                    <a-button class="mr-2" @click="editable.dly = false" type="default">Zrušit</a-button>
                    <a-button html-type="submit" type="primary" :disabled="loading || hasErrors(forms.dly.getFieldsError())">Upravit</a-button>
                  </div>
                </a-form>
              </div>
            </div>
          </a-col>
          <a-col :xl="6" :md="8" :sm="12" :xs="24">
            <div class="card card--withShadow card--more_on-hover">
              <div class="card-header">
                <div class="utils__title">
                  <strong>Kontakt</strong>
                </div>
                <div class="card--more">
                  <a-button type="circle" icon="edit" @click="editable.contact = true"></a-button>
                </div>
              </div>
              <div class="card-body">
                <div v-if="!editable.contact">
                  <abbr title="Telefon" class="mr-2">Telefon:</abbr>{{ detail.order_info.ahe_telephone_number }}<br>
                  <div v-if="detail.order_info.email">
                    <abbr title="E-mail" class="mr-2">E-mail:</abbr>{{ detail.order_info.email }}<br>
                  </div>
                </div>
                <a-form :form="forms.contact" layout="horizontal" @submit="updateContact($event, detail.order_info.big_ahe_id, forms.contact, 'contact')" v-else>
                  <a-form-item
                    label="Telefon"
                    :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol"
                    :validate-status="error('ahe_telephone_number') ? 'error' : ''"
                    :help="error('ahe_telephone_number') || ''"
                  >
                    <a-input placeholder="Telefon" v-decorator="['ahe_telephone_number', { initialValue: detail.order_info.ahe_telephone_number, rules: [{required: true, message: 'Telefon musí být vyplněn!'}, {max: 20, message: 'Telefon nemůže být delší než 20 znaků!'}]}]"/>
                  </a-form-item>
                  <a-form-item
                    label="E-mail"
                    :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol"
                    :validate-status="error('email') ? 'error' : ''"
                    :help="error('email') || ''"
                  >
                    <a-input placeholder="E-mail" v-decorator="['email', { initialValue: detail.order_info.email, rules: [{max: 100, message: 'E-mail nemůže být delší než 100 znaků!'}]}]"/>
                  </a-form-item>
                  <div class="form-actions">
                    <a-button class="mr-2" @click="editable.contact = false" type="default">Zrušit</a-button>
                    <a-button html-type="submit" type="primary" :disabled="loading || hasErrors(forms.contact.getFieldsError())">Upravit</a-button>
                  </div>
                </a-form>
              </div>
            </div>
          </a-col>
        </a-row>
        <a-row type="flex" justify="start" :gutter="30">
          <a-col :xl="6" :md="8" :sm="12" :xs="24" v-if="detail.order_info.is_company">
            <div class="card card--withShadow card--more_on-hover">
              <div class="card-header">
                <div class="utils__title">
                  <strong>Firemní údaje</strong>
                </div>
                <div class="card--more">
                  <a-button type="circle" icon="edit" @click="editable.company = true"></a-button>
                </div>
              </div>
              <div class="card-body">
                <div v-if="!editable.company">
                  <abbr title="Firma" class="mr-2">Firma:</abbr>{{ detail.order_info.ahe_company_name }}<br>
                  <div v-if="detail.order_info.ahe_vatin !== null">
                    <abbr title="DIČ" class="mr-2">DIČ:</abbr>{{ detail.order_info.ahe_vatin }}<br>
                  </div>
                  <div v-if="detail.order_info.ahe_tin !== null">
                    <abbr title="IČ" class="mr-2">IČ:</abbr>{{ detail.order_info.ahe_tin }}
                  </div>
                </div>
                <a-form :form="forms.company" layout="horizontal" @submit="updateCompany($event, detail.order_info.big_ahe_id, forms.company, 'company')" v-else>
                  <a-form-item
                    label="Firma"
                    :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol"
                    :validate-status="error('ahe_company_name') ? 'error' : ''"
                    :help="error('ahe_company_name') || ''"
                  >
                    <a-input placeholder="Firma" v-decorator="['ahe_company_name', { initialValue: detail.order_info.ahe_company_name, rules: [{max: 100, message: 'Firma nemůže být delší než 100 znaků!'}]}]"/>
                  </a-form-item>
                  <a-form-item
                    label="DIČ"
                    :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol"
                    :validate-status="error('ahe_vatin') ? 'error' : ''"
                    :help="error('ahe_vatin') || ''"
                  >
                    <a-input placeholder="DIČ" v-decorator="['ahe_vatin', { initialValue: detail.order_info.ahe_vatin, rules: [{max: 20, message: 'DIČ nemůže být delší než 20 znaků!'}]}]"/>
                  </a-form-item>
                  <a-form-item
                    label="IČ"
                    :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol"
                    :validate-status="error('ahe_tin') ? 'error' : ''"
                    :help="error('ahe_tin') || ''"
                  >
                    <a-input placeholder="IČ" v-decorator="['ahe_tin', { initialValue: detail.order_info.ahe_tin, rules: [{max: 20, message: 'IČ nemůže být delší než 20 znaků!'}]}]"/>
                  </a-form-item>
                  <div class="form-actions">
                    <a-button class="mr-2" @click="editable.company = false" type="default">Zrušit</a-button>
                    <a-button html-type="submit" type="primary" :disabled="loading || hasErrors(forms.company.getFieldsError())">Upravit</a-button>
                  </div>
                </a-form>
              </div>
            </div>
          </a-col>
          <a-col :xl="6" :md="8" :sm="12" :xs="24">
            <div class="card card--withShadow card--more_on-hover">
              <div class="card-header">
                <div class="utils__title">
                  <strong>Doprava</strong>
                </div>
                <div class="card--more">
                  <a-button type="circle" icon="edit" @click="editable.delivery = true"></a-button>
                </div>
              </div>
              <div class="card-body">
                <div v-if="!editable.delivery">
                  <span v-if="!item.delivery.changed">{{ detail.order_info.dhe_name }}</span>
                  <span v-else>{{ deliveryName(detail.order_info.dhy_id) }}</span>
                  : {{ detail.order_info.delivery_total | currency }}
                </div>
                <a-form :form="forms.delivery" @submit="updateDeliveryPayment($event, detail.order_info.odr_id, forms.delivery, 'delivery')" v-else>
                  <a-form-item
                    label="Doprava"
                    :validate-status="error('dhy_id') ? 'error' : ''"
                    :help="error('dhy_id') || ''"
                  >
                    <a-select v-decorator="['dhy_id', { initialValue: detail.order_info.dhy_id, rules: [{required: true, message: 'Doprava musí být vyplněna!'}]}]">
                      <a-select-option v-if="!item.delivery.found" :value="detail.order_info.dhy_id" :loading="loading">{{ detail.order_info.dhe_name }}</a-select-option>
                      <a-select-option v-for="delivery in deliveries" :value="delivery.current_history.dhy_id" :key="'dhy_id'+delivery.current_history.dhy_id" :loading="loading">{{ delivery.current_history.languages[0].pivot.dhe_name }}</a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item
                    :label="'Cena [' + this.$currency + ']'"
                    :validate-status="error('delivery_total') ? 'error' : ''"
                    :help="error('delivery_total') || ''"
                  >
                    <a-input-number :min="0" :placeholder="'Cena [' + this.$currency + ']'" v-decorator="['delivery_total', { initialValue: detail.order_info.delivery_total, rules: [{required: true, message: 'Cena musí být vyplněna!'}]}]"/>
                  </a-form-item>

                  <div class="form-actions">
                    <a-button class="mr-2" @click="editable.delivery = null" type="default">Zrušit</a-button>
                    <a-button html-type="submit" type="primary" :disabled="loading || hasErrors(form.getFieldsError())">Upravit</a-button>
                  </div>
                </a-form>
              </div>
            </div>
          </a-col>
          <a-col :xl="6" :md="8" :sm="12" :xs="24">
            <div class="card card--withShadow card--more_on-hover">
              <div class="card-header">
                <div class="utils__title">
                  <strong>Platba</strong>
                </div>
                <div class="card--more">
                  <a-button type="circle" icon="edit" @click="editable.payment = true"></a-button>
                </div>
              </div>
              <div class="card-body">
                <div v-if="!editable.payment">
                  <span v-if="!item.payment.changed">{{ detail.order_info.phe_name }}</span>
                  <span v-else>{{ paymentName(detail.order_info.pty_id) }}</span>
                  : {{ detail.order_info.payment_total | currency }}
                </div>
                <a-form :form="forms.payment" @submit="updateDeliveryPayment($event, detail.order_info.odr_id, forms.payment, 'payment')" v-else>
                  <a-form-item
                    label="Platba"
                    :validate-status="error('pty_id') ? 'error' : ''"
                    :help="error('pty_id') || ''"
                  >
                    <a-select v-decorator="['pty_id', { initialValue: detail.order_info.pty_id, rules: [{required: true, message: 'Platba musí být vyplněna!'}]}]">
                      <a-select-option v-if="!item.payment.found" :value="detail.order_info.pty_id" :loading="loading">{{ detail.order_info.phe_name }}</a-select-option>
                      <a-select-option v-for="payment in payments" :value="payment.current_history.pty_id" :key="'phy_id' + payment.current_history.pty_id" :loading="loading">{{ payment.current_history.languages[0].phe_name }}</a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item
                    :label="'Cena [' + this.$currency + ']'"
                    :validate-status="error('payment_total') ? 'error' : ''"
                    :help="error('payment_total') || ''"
                  >
                    <a-input-number :min="0" :placeholder="'Cena [' + this.$currency + ']'" v-decorator="['payment_total', { initialValue: detail.order_info.payment_total, rules: [{required: true, message: 'Cena musí být vyplněna!'}]}]"/>
                  </a-form-item>

                  <div class="form-actions">
                    <a-button class="mr-2" @click="editable.payment = null" type="default">Zrušit</a-button>
                    <a-button html-type="submit" type="primary" :disabled="loading || hasErrors(form.getFieldsError())">Upravit</a-button>
                  </div>
                </a-form>
              </div>
            </div>
          </a-col>
          <a-col :xl="6" :md="8" :sm="12" :xs="24" v-if="detail.order_info.note !== null">
            <div class="card card--withShadow card--more_on-hover">
              <div class="card-header">
                <div class="utils__title">
                  <strong>Poznámka zákazníka</strong>
                </div>
              </div>
              <div class="card-body">
                {{ detail.order_info.note }}
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
      <div v-if="tabActiveKey === 'product'">
        <div class="card">
          <div class="card-header">
            <div class="utils__title">
              <strong>Produkty</strong>
            </div>
            <div class="action-tools">
              <div class="links">
                <a-popconfirm placement="bottomLeft" @confirm="confirmAddItem" okText="Potvrdit" cancelText="Zrušit">
                  <a-icon slot="icon" type="info-circle" class="text-primary" />
                  <template slot="title">
                    <p>Vyberte si produkt, který chcete přidat</p>
                    <a-tree-select
                      style="display:block;"
                      :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
                      :treeData="treeData"
                      placeholder="-- Vyber kategorii --"
                      @change="this.changeCategory"
                      :value="selectedCategory"
                      :loading="item.categories.loading"
                    >
                    </a-tree-select>
                    <a-select
                      class="mt-2"
                      showSearch
                      placeholder="-- Vyberte si produkt --"
                      optionFilterProp="children"
                      @change="handleSelectProductChange"
                      :value="item.product.active"
                      style="width: 100%"
                      :loading="item.product.loading"
                      :filterOption="filterOption"
                      :options="products.map((x, index) => { return { value: index.toString(), label: x.history_languages.length > 0 ? '# ' + x.put_id + ' | ' + x.history_languages[0].pivot.phe_name : '# ' + x.put_id + ' | není nastaveno' } })"
                    >
                    </a-select>
                    <a-select
                      class="mt-2"
                      showSearch
                      placeholder="-- Vyberte si variantu produktu --"
                      optionFilterProp="children"
                      @change="handleSelectProductOptionChange"
                      :value="item.product.pon_id"
                      style="width: 100%"
                      :loading="item.product.loading"
                      :filterOption="filterOption"
                      :options="item.product.selected === null ? [] : item.product.selected.current_options.map(x => { return { value: x.pon_id.toString(), label: x.languages.length > 0 ? '# ' + x.pon_id + ' | ' + x.languages[0].pivot.poe_name : '# ' + x.pon_id + ' | není nastaveno' } })"
                    >
                    </a-select>
                    <p class="mt-2"><span class="utils__link--underlined">Cena s DPH:</span> {{ (item.product.selected === null ? 0 : (item.product.selected.current_history.phy_price_vat - ((item.product.selected.current_history.phy_price_vat * item.product.discount) / 100))) | currency }}</p>
                    <a-input-number
                      :min="1"
                      :step="1"
                      v-model="item.product.oim_quantity"
                      placeholder="Množství"></a-input-number>&nbsp;ks
                    <a-input-number
                      class="mt-2 d-block" placeholder="Sleva %" :min="0" :max="100" :step="0.01" :precision="2"
                      v-model="item.product.discount" :defaultValue="0" />
                    <p class="mt-2"><span class="utils__link--underlined">Celkem s DPH:</span>
                      {{ (item.product.selected === null ? 0 : (item.product.selected.current_history.phy_price_vat - ((item.product.selected.current_history.phy_price_vat * item.product.discount) / 100)) * item.product.oim_quantity) | currency }}
                    </p>
                  </template>
                  <a-tooltip title="Přidat položku">
                    <a-icon
                      type="plus-circle"
                      :style="{ fontSize: '1.38rem' }"
                      theme="twoTone"
                      @click="clickAddItem"
                    >
                    </a-icon>
                  </a-tooltip>
                </a-popconfirm>
              </div>
            </div>
          </div>
          <div class="card-body">
            <a-table
              tableLayout="auto"
              :rowKey="record => record.put_id"
              :columns="columns"
              :loading="loading"
              :dataSource="detail.items"
              class="utils__scrollTable"
              :scroll="{ x: '100%' }"
            >
              <router-link
                slot="put_id"
                slot-scope="value"
                class="utils__link--underlined"
                :to="'/ecommerce/product/detail/' + value"
              >#{{value}}
              </router-link>
              <span
                slot="price"
                slot-scope="text"
              >
                {{ text | currency }}
              </span>
              <span slot="product_name" slot-scope="record">
                {{ record.phe_name + (record.poe_name ? ' - ' + record.poe_name : '') }}
              </span>
              <span
                slot="discount"
                slot-scope="text"
              >
                {{ text }} %
              </span>
              <template slot="quantity" slot-scope="record">
                <editable-cell
                  :input-value="record.oim_quantity"
                  :text="($options.filters.number(record.oim_quantity, '0,0') + ' ks')"
                  @change="onQuantityChange(record, $event)"
                />
              </template>
              <span slot="weight_total" slot-scope="record" v-if="record.per_piece">
                {{ record.weight_total | number('0,0') }} g
              </span>
              <span slot="action" slot-scope="record">
                <a-popconfirm @confirm="confirmDeleteItem(record.oim_id)" okText="Potvrdit" cancelText="Zrušit">
                  <template slot="title">
                      <p>Opravdu si přejete odstranit položku: #{{ record.put_id }} ?</p>
                  </template>
                  <a-button icon="delete" size="small">Odstranit</a-button>
                </a-popconfirm>
              </span>
            </a-table>
          </div>
        </div>
        <a-row type="flex" justify="end">
          <a-col :span="6" :xl="6" :md="8" :sm="12" :xs="24">
            <div class="card card--withShadow card--more_on-hover">
              <div class="card-body">
                <abbr title="Zboží" class="mr-2">Zboží:</abbr>{{ detail.order_info.order_total_vat - detail.order_info.delivery_total - detail.order_info.payment_total  | currency }}<br>
                <abbr title="Doprava" class="mr-2">Doprava:</abbr>{{ detail.order_info.delivery_total | currency }}<br>
                <abbr title="Platba" class="mr-2">Platba:</abbr>{{ detail.order_info.payment_total | currency }}<br>
                <abbr title="Celkem s DPH" class="mr-2">Celkem s DPH:</abbr>{{ detail.order_info.order_total_vat | currency }}<br>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
      <div v-if="tabActiveKey === 'note'">
        <a-row type="flex" justify="start" :gutter="30">
          <a-col :xl="8" :md="12" :xs="24" v-for="item in detail.notes" :key="'note'+item.one_id">
            <div class="card card--withShadow">
              <div class="card-header">
                <div class="utils__titleDescription">Posledně upraveno: {{ toLocaleDate(item.updated_at) }}</div>
                <div><small>Admin: <router-link class="utils__link--underlined text-primary" :to="'/user/admin/detail/' + item.uer_id">#{{ item.uer_id }}</router-link></small></div>

                <div class="card--more">
                  <a-dropdown :placement="'bottomRight'">
                    <a-button type="circle">
                      <a-icon type="ellipsis" :rotate="90"></a-icon>
                    </a-button>
                    <a-menu slot="overlay" @click="clickActionNote($event, item)">
                      <a-menu-item :key="0">
                        <a-icon type="edit" class="mr-2"></a-icon>Upravit
                      </a-menu-item>
                      <a-menu-item :key="1">
                        <a-popconfirm @confirm="deleteNote(item)" okText="Potvrdit" cancelText="Zrušit">
                          <template slot="title">
                            <p>Opravdu si přejete odstranit položku: #{{ item.one_id }} ?</p>
                          </template>
                          <a-icon type="delete" class="mr-2"></a-icon>Odstranit
                        </a-popconfirm>
                      </a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </div>
              </div>
              <div class="card-body">
                <div v-if="editable.note !== item.one_id">
                  <div class="utils__title">
                    <strong>{{ item.one_title }}</strong>
                  </div>
                  {{ item.one_content }}
                </div>
                <a-form :form="form" @submit="onSubmitUpdateNote($event, item)" v-else>
                  <a-form-item
                    label="Nadpis"
                    :validate-status="error('one_title') ? 'error' : ''"
                    :help="error('one_title') || ''"
                  >
                    <a-input placeholder="Nadpis" v-decorator="['one_title', { initialValue: item.one_title, rules: [{max: 50, message: 'Nadpis nemůže být delší než 50 znaků!'}, {required: true, message: 'Nadpis musí být vyplněn!'}]}]"/>
                  </a-form-item>

                  <a-form-item
                    label="Obsah"
                    :validate-status="error('one_content') ? 'error' : ''"
                    :help="error('one_content') || ''"
                  >
                    <a-textarea :autoSize="{ minRows: 4, maxRows: 10 }" placeholder="Obsah" v-decorator="['one_content', {initialValue: item.one_content, rules: [{required: true, message: 'Obsah musí být vyplněn!'}]}]"/>
                  </a-form-item>

                  <div class="form-actions">
                    <a-button class="mr-2" @click="editable.note = null" type="default">Zrušit</a-button>
                    <a-button html-type="submit" type="primary" :disabled="loading || hasErrors(form.getFieldsError())">Upravit</a-button>
                  </div>
                </a-form>
              </div>
            </div>
          </a-col>
          <a-col :xl="6" :md="8" :sm="12" :xs="24">
            <a-button
              type="dashed"
              block
              size="large"
              @click="onClickAddNote"
              v-if="!isAddNote"
            >
              <a-icon type="plus" /> Přidat poznámku
            </a-button>
            <div class="card" v-else>
              <div class="card-body">
                <a-form :form="form" @submit="onSubmitAddNote">
                  <a-form-item
                    label="Nadpis"
                    :validate-status="error('one_title') ? 'error' : ''"
                    :help="error('one_title') || ''"
                  >
                    <a-input placeholder="Nadpis" v-decorator="['one_title', {rules: [{max: 50, message: 'Nadpis nemůže být delší než 50 znaků!'}, {required: true, message: 'Nadpis musí být vyplněn!'}]}]"/>
                  </a-form-item>

                  <a-form-item
                    label="Obsah"
                    :validate-status="error('one_content') ? 'error' : ''"
                    :help="error('one_content') || ''"
                  >
                    <a-textarea :autoSize="{ minRows: 4, maxRows: 10 }" placeholder="Obsah" v-decorator="['one_content', {rules: [{required: true, message: 'Obsah musí být vyplněn!'}]}]"/>
                  </a-form-item>

                  <div class="form-actions">
                    <a-button class="mr-2" @click="isAddNote = !isAddNote" type="default">Zrušit</a-button>
                    <a-button html-type="submit" type="primary" :disabled="loading || hasErrors(form.getFieldsError())">Přidat</a-button>
                  </div>
                </a-form>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
      <div v-if="tabActiveKey === 'history'">
        <div class="card">
          <div class="card-body">
            <a-timeline mode="alternate">
              <a-timeline-item :color="statuses.find(x => x.status === item.ohy_status).color" v-for="item in detail.histories" :key="'time' + item.ohy_id">{{ statuses.find(x => x.status === item.ohy_status).text }} {{ toLocaleDate(item.ohy_date_from) }}</a-timeline-item>
            </a-timeline>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ActionTools from '@/components/MyComponents/ActionTools'
import EditableCell from '@/components/MyComponents/EditableCell'
import { hasErrors } from '../../../../services/forms'

export default {
  components: {
    ActionTools, EditableCell,
  },
  beforeCreate() {
    this.form = this.$form.createForm(this)
  },
  data() {
    return {
      id: this.$route.params.id,
      editable: {
        big: false,
        payment: false,
        delivery: false,
        info: false,
        dly: false,
        contact: false,
        company: false,
        note: null,
      },
      treeData: [],
      item: {
        delivery: {
          found: false,
          changed: false,
        },
        payment: {
          found: false,
          changed: false,
        },
        categories: {
          loading: false,
        },
        product: {
          selected: null,
          loading: false,
          pon_id: null,
          oim_quantity: 1,
          discount: 0,
          active: null,
        },
      },
      forms: {
        big: this.$form.createForm(this),
        dly: this.$form.createForm(this),
        payment: this.$form.createForm(this),
        delivery: this.$form.createForm(this),
        info: this.$form.createForm(this),
        contact: this.$form.createForm(this),
        company: this.$form.createForm(this),
      },
      loading: false,
      formItemLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
      },
      hasErrors,
      tabActiveKey: 'info',
      isAddNote: false,
      searchText: '',
      routerOptions: [
        {
          icon: 'bars',
          theme: 'outlined',
          to: '/ecommerce/order',
          title: 'Seznam',
        },
      ],
      tabList: [
        {
          key: 'info',
          tab: 'Informace',
        },
        {
          key: 'product',
          tab: 'Produkty',
        },
        {
          key: 'note',
          tab: 'Poznámky',
        },
        {
          key: 'history',
          tab: 'Historie',
        },
      ],
      columns: [
        {
          title: 'ID',
          dataIndex: 'put_id',
          defaultSortOrder: 'ascend',
          sorter: (a, b) => a.put_id - b.put_id,
          scopedSlots: {
            customRender: 'put_id',
          },
        },
        {
          title: 'Produkt',
          dataIndex: '',
          sorter: (a, b) => {
            return a.phe_name.localeCompare(b.phe_name)
          },
          scopedSlots: {
            customRender: 'product_name',
          },
        },
        {
          title: 'Sleva',
          dataIndex: 'discount',
          sorter: (a, b) => {
            return a.discount - b.discount
          },
          scopedSlots: {
            customRender: 'discount',
          },
        },
        {
          title: 'Cena bez DPH',
          dataIndex: 'price_item_with_discount_without_vat',
          sorter: (a, b) => {
            return a.price_item_with_discount_without_vat - b.price_item_with_discount_without_vat
          },
          scopedSlots: {
            customRender: 'price',
          },
        },
        {
          title: 'Cena s DPH',
          dataIndex: 'price_item_with_discount_with_vat',
          sorter: (a, b) => {
            return a.price_item_with_discount_with_vat - b.price_item_with_discount_with_vat
          },
          scopedSlots: {
            customRender: 'price',
          },
        },
        {
          title: 'Množství',
          dataIndex: '',
          scopedSlots: {
            customRender: 'quantity',
          },
        },
        {
          title: 'Celkem bez DPH',
          dataIndex: 'price_total_with_discount_without_vat',
          sorter: (a, b) => {
            return a.price_total_with_discount_without_vat - b.price_total_with_discount_without_vat
          },
          scopedSlots: {
            customRender: 'price',
          },
        },
        {
          title: 'Celkem s DPH',
          dataIndex: 'price_total_with_discount_with_vat',
          sorter: (a, b) => {
            return a.price_total_with_discount_with_vat - b.price_total_with_discount_with_vat
          },
          scopedSlots: {
            customRender: 'price',
          },
        },
        {
          title: '',
          dataIndex: '',
          scopedSlots: {
            customRender: 'action',
          },
        },
      ],
    }
  },
  computed: {
    detail: function () {
      return this.$store.getters['order/getDetail']
    },
    language: function() {
      return this.$store.getters['language/active']
    },
    countries: function () {
      return this.$store.getters['country/currentLanguage']('')
    },
    deliveries: function () {
      return this.$store.getters['delivery/currentLanguage']('')
    },
    payments: function () {
      return this.$store.getters['payment/currentLanguage']('')
    },
    statuses: function () {
      return this.$store.getters['order/getStatuses']
    },
    products: function () {
      return this.$store.getters['product/currentLanguage']('')
    },
    selectedCategory: function () {
      return this.$store.getters['category/getActive']
    },
    categories: function () {
      return this.$store.getters['category/currentLanguage']
    },
  },
  methods: {
    countryName(id) {
      let name = ''
      this.countries.some((value) => {
        if (value.id === id) {
          name = value.languages[0].pivot.name
          return true
        }
      })
      return name
    },
    changeCategory(key) {
      this.$store.commit('category/SET_ACTIVE', key.toString())
      this.loadProducts()
    },
    handleSelectProductChange(e) {
      this.item.product.active = e
      this.item.product.selected = e === null ? null : this.products[parseInt(e)]
    },
    handleSelectProductOptionChange(e) {
      this.item.product.pon_id = e === null ? null : parseInt(e)
    },
    clickAddItem() {
      if (this.categories.length === 0) {
        this.item.categories.loading = true
        this.$store.dispatch('category/getList')
          .then(() => {
            if (this.categories.length > 0) {
              this.changeCategory(this.categories[0].cey_id)
            }
          })
          .catch(() => {})
          .finally(() => {
            this.item.categories.loading = false
          })
      }
    },
    loadProducts() {
      this.item.product.loading = true
      this.$store.dispatch('product/getList')
        .then(() => {
          this.handleSelectProductChange(null)
          this.handleSelectProductOptionChange(null)
        })
        .catch(() => {})
        .finally(() => {
          this.item.product.loading = false
        })
    },
    paymentName(id) {
      let name = ''
      this.payments.some((value) => {
        if (value.current_history.pty_id === id) {
          name = value.current_history.languages[0].phe_name
          return true
        }
      })
      return name
    },
    deliveryName(id) {
      let name = ''
      this.deliveries.some((value) => {
        if (value.current_history.dhy_id === id) {
          name = value.current_history.languages[0].pivot.dhe_name
          return true
        }
      })
      return name
    },
    confirmAddItem() {
      this.loading = true
      const item = {
        oim_quantity: this.item.product.oim_quantity,
        discount: this.item.product.discount,
        put_id: this.item.product.selected === null ? null : this.item.product.selected.put_id,
        odr_id: parseInt(this.id),
        pon_id: this.item.product.pon_id,
      }
      this.$store.dispatch('order/postItem', { id: this.detail.order_info.odr_id, item: item })
        .then(() => {
          this.handleRefresh()
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    updateDeliveryPayment(e, id, form, editable) {
      e.preventDefault()
      form.validateFields((err, values) => {
        if (!err) {
          if (values.dhy_id) {
            this.deliveries.some((value) => {
              if (value.current_history.dhy_id === values.dhy_id) {
                values.dly_id = value.dly_id
                return true
              }
            })
          } else {
            this.payments.some((value) => {
              if (value.current_history.pty_id === values.pty_id) {
                values.pmt_id = value.pmt_id
                return true
              }
            })
          }
          this.loading = true
          this.$store.dispatch('order/putDeliveryPayment', { id: id, data: values })
            .then(() => {
              this.editable[editable] = false
              this.item[editable].changed = true
            })
            .catch(() => {})
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    onQuantityChange(record, value) {
      this.loading = true
      this.$store.dispatch('order/putItemQuantity', { id: this.id, item: record, quantity: value })
        .then(() => {
          this.editable.note = null
          this.handleRefresh()
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    clickActionNote(e, item) {
      if (e.key === 0) {
        this.editable.note = item.one_id
      }
    },
    updateAddress(e, id, form, editable) {
      e.preventDefault()
      form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          this.$store.dispatch('address/putHistory', { id: id, item: values })
            .then(() => {
              this.editable[editable] = false
              this.$store.commit('order/UPDATE_ADDRESS', { data: values, type: editable })
            })
            .catch(() => {})
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    updateContact(e, id, form, editable) {
      e.preventDefault()
      form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          values.ahe_id = id
          this.$store.dispatch('order/putContact', { id: this.detail.order_info.odr_id, data: values })
            .then(() => {
              this.editable[editable] = false
            })
            .catch(() => {})
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    updateCompany(e, id, form, editable) {
      e.preventDefault()
      form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          values.ahe_id = id
          this.$store.dispatch('order/putCompany', { id: this.detail.order_info.odr_id, data: values })
            .then(() => {
              this.editable[editable] = false
            })
            .catch(() => {})
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    updateInfo(e, form, editable) {
      e.preventDefault()
      form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          this.$store.dispatch('order/status', { status: form.getFieldValue('status'), sent: false, items: [Number.parseInt(this.id)] })
            .then(() => {
              this.editable[editable] = false
            }).catch(() => {})
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    deleteNote(item) {
      this.loading = true
      this.$store.dispatch('order/deleteNote', item)
        .then(() => {
          this.editable.note = null
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    confirmDeleteItem(item) {
      this.loading = true
      this.$store.dispatch('order/deleteItem', { id: this.detail.order_info.odr_id, item: item })
        .then(() => {
          this.handleRefresh()
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    onSubmitUpdateNote(e, item) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          this.$store.dispatch('order/putNote', { id: item.one_id, item: values })
            .then(() => {
              this.editable.note = null
            })
            .catch(() => {})
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    error(fieldName) {
      const { getFieldError, isFieldTouched } = this.form
      return isFieldTouched(fieldName) && getFieldError(fieldName)
    },
    onClickAddNote() {
      this.isAddNote = true
    },
    onSubmitAddNote(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          this.$store.dispatch('order/postNote', { odr_id: this.id, one_title: this.form.getFieldValue('one_title'), one_content: this.form.getFieldValue('one_content') })
            .catch(() => {})
            .finally(() => {
              this.loading = false
              this.isAddNote = false
            })
        }
      })
    },
    onTabChange(key, type) {
      this[type] = key
    },
    toLocaleDate: function (text) {
      return this.$options.filters.formatDate(text)
    },
    loadCountries() {
      this.loading = true
      this.$store.dispatch('country/getList')
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    loadDeliveries() {
      this.loading = true
      this.$store.dispatch('delivery/getList')
        .then(() => {
          this.deliveries.some((value) => {
            if (value.current_history.dhy_id === this.detail.order_info.dhy_id) {
              this.item.delivery.found = true
              return true
            }
          })
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    loadPayments() {
      this.loading = true
      this.$store.dispatch('payment/getList')
        .then(() => {
          this.payments.some((value) => {
            if (value.current_history.pty_id === this.detail.order_info.pty_id) {
              this.item.payment.found = true
              return true
            }
          })
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    handleRefresh() {
      this.loading = true
      this.$store.dispatch('order/getOne', this.id)
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    toTreeData(data) {
      return data.map(x => {
        return {
          key: 'cey' + x.cey_id,
          value: x.cey_id,
          title: '#' + x.cey_id + ' | ' + (x.languages.length > 0 ? x.languages[0].pivot.cle_name : 'není nastaveno'),
          children: this.toTreeData(x.all_children),
        }
      })
    },
    initItem() {
      this.item = {
        delivery: {
          found: false,
          changed: false,
        },
        payment: {
          found: false,
          changed: false,
        },
        categories: {
          loading: false,
        },
        product: {
          selected: null,
          loading: false,
          pon_id: null,
          oim_quantity: 1,
          discount: 0,
          active: null,
        },
      }
    },
  },
  created() {
    this.handleRefresh()
    if (this.categories.length !== 0) {
      this.treeData = this.toTreeData(this.categories)
    }
  },
  watch: {
    selectedCategory(newValue, oldValue) {
      if (newValue !== null && newValue !== oldValue) {
        this.loadProducts()
      }
    },
    categories(newValue, oldValue) {
      if (newValue !== null && newValue.length > 0) {
        this.treeData = this.toTreeData(this.categories)
      }
    },
    'editable.big'() {
      if (this.countries.length === 0 && this.language) {
        this.loadCountries()
      }
    },
    'editable.dly'() {
      if (this.countries.length === 0 && this.language) {
        this.loadCountries()
      }
    },
    'editable.payment'() {
      if (this.payments.length === 0 && this.language) {
        this.loadPayments()
      }
    },
    'editable.delivery'() {
      if (this.deliveries.length === 0 && this.language) {
        this.loadDeliveries()
      }
    },
    '$route.params.id'(newId, oldId) {
      this.id = newId
      this.initItem()
      this.handleRefresh()
    },
  },
}
</script>

<style lang="scss" module>
  @import "./style.module.scss";
</style>
